<cpc-badge [variant]="variant">{{badgeText | translate}}</cpc-badge>
